'use strict';

const _ = require('underscore');
const i18n = require('i18next');
const Moment = require('moment');
const StateType = require('process/domain/entity/state-type');
const ActionAPI = require('process/infra/api/action/index');
const ActionFactory = require('process/domain/factory/action/index');
const ActionRepository = require('process/domain/repository/action/index');
const ActionTypeRepository = require('process/domain/repository/action/type');
const Snackbar = require('common/util/snackbar');

class Service {
    constructor(project, actionJSON) {
        this._project = project;
        this._actionJSON = actionJSON;
    }

    create() {
        if(!this._validate()) {
            return new Promise((resolve, reject) => {
                reject();
            });
        }

        return ActionTypeRepository.find(this._project).getAll()
            .then(actionTypes => {
                //TODO: remove following!
                const type = _.find(actionTypes, at => at.getName() == 'Action');
                this._actionJSON.type = type.id;
                const state = type.getStateByType(StateType.get('initial').name);
                this._actionJSON.state = state.id;

                return ActionRepository.find(this._project).get(this._actionJSON.parent);
            })
            .then(p => {
                return p.getChildren();
            })
            .then(children => {
                let x;
                if (children.length > 0) {
                    x = children.chain()
                            .map(p => p.get('point').x)
                            .max().value() + 256 * 3;
                } else {
                    x = 0;
                }
                this._actionJSON.point.x = x;

                return ActionAPI.create(this._project.id, this._actionJSON);
            })
            .then(j => {
                const factory = new ActionFactory(this._project);
                const repo = ActionRepository.find(this._project);

                return factory.build(j, repo)
            })
            .then(_action => {
                const action = ActionRepository.find(this._project).add(_action);

                Snackbar.success(
                    i18n.t('process:feedback.create', {
                        name: action.getName()
                    })
                );

                return action
            });
    }

    _validate() {
        const startAt = this._actionJSON.startAt;
        const endAt = this._actionJSON.endAt;

        if(startAt && endAt) {
            if(Moment(endAt).diff(startAt) < 0) {
                Snackbar.error(
                    i18n.t('process:feedback.dateOrderError')
                );
                return false;
            }
        }

        return true;
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./process/app/service/action/create.js